module.exports = __webpack_public_path__ + "static/media/rainbow_SP.20c60f7b.png";